export const AIRCRAFT_TRIP_MODULE_KEY = 'pre-flight/feature-aircraft-trip';
export const AIRCRAFT_TRIP_BETA_MODULE_KEY = 'pre-flight/feature-aircraft-trip-beta';

export enum Source {
  DraftTrip = 'draft-trip'
}
